import { IconProps } from "./dto";

export function TrashIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} onClick={props.onClick} viewBox="0 0 18 18" fill="none">
            <path stroke={props.color && props.color || "#8383AD"} d="M2.25 4.5H3.75M3.75 4.5H15.75M3.75 4.5V15C3.75 15.3978 3.90804 15.7794 4.18934 16.0607C4.47064 16.342 4.85218 16.5 5.25 16.5H12.75C13.1478 16.5 13.5294 16.342 13.8107 16.0607C14.092 15.7794 14.25 15.3978 14.25 15V4.5H3.75ZM6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72065 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5M7.5 8.25V12.75M10.5 8.25V12.75" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
